import { Outlet } from 'react-router-dom';
import Header from './Components/Templates/Header';
import Footer from './Components/Templates/Footer';

function App() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

export default App;
